import {
  fetchCollection
} from './index'

import { serviceSummarySchema } from '../schemas'

export const WORK_ORDER_SUMMARIES_REQUEST = 'WORK_ORDER_SUMMARIES_REQUEST'
export const WORK_ORDER_SUMMARIES_SUCCESS = 'WORK_ORDER_SUMMARIES_SUCCESS'
export const WORK_ORDER_SUMMARIES_FAILURE = 'WORK_ORDER_SUMMARIES_FAILURE'

export function fetchServiceSummariesForWorkOrder (workOrderId) {
  return fetchCollection({
    url: `/work_orders/${workOrderId}/service_summaries`,
    key: 'serviceSummaries',
    schema: serviceSummarySchema,
    actions: [ WORK_ORDER_SUMMARIES_REQUEST, WORK_ORDER_SUMMARIES_SUCCESS, WORK_ORDER_SUMMARIES_FAILURE ],
    responseInterceptor: response => ({ ...response, workOrderId })
  })
}



// WEBPACK FOOTER //
// ./src/actions/service-summaries.js